import React from "react";
import FilterSidebarForm from "@/modules/hub/features/ResourceLibraryV2/components/FilterSidebar/SidebarForm/FilterSidebarForm";
import { UseFormReturn } from "react-hook-form";
import { ResourceLibraryMetadataFilters } from "@/modules/hub/features/ResourceLibraryV2/api/getResourceLibratyMetadata/types";
import { FilterSidebarFormData } from "@/modules/hub/features/ResourceLibraryV2/hooks/FilterSidebarFormSchema";
import { useIsMobile } from "@/hooks/use-mobile";
import ProcessWheelCard from "@/modules/hub/features/ResourceLibraryV2/components/FilterSidebar/ProcessWheelCard/ProcessWheelCard";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

interface FilterSidebarProps {
  form: UseFormReturn<FilterSidebarFormData>;
  filters: ResourceLibraryMetadataFilters | null;
  isLoading: boolean;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  showProcessWheel?: boolean;
  showJobTitle?: boolean;
}

export const FilterSidebar: React.FC<FilterSidebarProps> = ({
  form,
  filters,
  isLoading,
  isOpen,
  onOpenChange,
  showProcessWheel = false,
  showJobTitle = true,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Sheet onOpenChange={onOpenChange} open={isOpen}>
        <SheetContent
          className="z-[70] h-screen p-6 overflow-y-auto"
          side="left"
          style={{ width: "100vw", maxWidth: "100vw" }}
        >
          {showProcessWheel && (
            <ProcessWheelCard
              form={form}
              processWheels={filters?.processWheels ?? []}
            />
          )}
          <SheetHeader>
            <SheetTitle>Filters</SheetTitle>
          </SheetHeader>
          <FilterSidebarForm
            filters={filters}
            form={form}
            loading={isLoading}
            onSubmit={() => {}}
            showJobTitle={showJobTitle}
            showProcessWheel={showProcessWheel}
          />
        </SheetContent>
      </Sheet>
    );
  }

  // Desktop view
  return (
    <aside className="w-full pt-4">
      {showProcessWheel && (
        <ProcessWheelCard
          form={form}
          processWheels={filters?.processWheels ?? []}
        />
      )}
      <h2 className="text-base font-medium text-gray-900 dark:text-slate-100 mb-1 pl-2 pr-4">
        Filters
      </h2>
      <p className="text-sm text-gray-500 dark:text-slate-400 mb-4 pl-2 pr-4">
        Refine your search results.
      </p>
      <div className="space-y-3 pl-2 pr-4 pb-6">
        <FilterSidebarForm
          filters={filters}
          form={form}
          loading={isLoading}
          onSubmit={() => {}}
          showJobTitle={showJobTitle}
          showProcessWheel={showProcessWheel}
        />
      </div>
    </aside>
  );
};
